module.exports = __webpack_public_path__ + "static/media/wp_7.1258d07d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wp_7.png
// module id = 36
// module chunks = 0